import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const KontaktUpravit = lazy(() =>
  import('@/modules/kontakty/KontaktUpravit').then((m) => ({ default: m.KontaktUpravit })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/kontakty/$id/upravit',
  component: () => (
    <Suspense fallback={null}>
      <KontaktUpravit />
    </Suspense>
  ),
});
